export default {
  MY_MESSAGES (state, payload) {
    if (payload && payload.results) {
      state.messages = payload.results
    }
  },
  MY_MESSAGE_THREAD  (state, payload) {
    if (payload && payload.results) {
      state.skip = state.skip + payload.results.length
      state.messageThread = payload.results.concat(state.messageThread)
    }
  },
  UPDATE_SKIP (state, payload) {
    state.skip = state.skip + payload
  },
  RESETTHREAD (state, payload) {
    state.messageThread = []
    state.skip = 0
  },
  UPDATE_MESSAGE_IN_THREAD (state, payload) {
    if (payload) {
      const index = state.messageThread.findIndex(message => message._id === payload._id)
      if (index > -1) {
        state.messageThread[index].messageFlaggedBy = payload.messageFlaggedBy
      }
    }
  },
  UPDATE_THREAD (state, payload) {
    if (payload) {
      const index = state.messages.findIndex(thread => thread.threadId === payload)
      if (index > -1) {
        state.messages[index].totalMessagesRead++
        state.messages[index].totalMessagesReadByMe++
        state.messages[index].totalUnreadMessages--
        state.messages[index].totalMessagesUnreadByMe--
      }
    }
  },
  ACTIVE_THREAD (state, payload) {
    if (payload) {
      state.activeThread = payload
    }
  },
  MESSAGE_THREAD_PARTICIPANTS (state, payload) {
    let participantFound = false
    if (payload) {
      for (let i = 0; i < state.participants.length; i++) {
        if (state.participants[i]._id === payload._id) {
          participantFound = true
          state.participants[i] = payload
        }
      }
      if (!participantFound) {
        state.participants.push(payload)
      }
    } else {
      state.participants = []
    }
  },
  PARTICIPANTS_CONSENT (state, payload) {
    if (payload) {
      state.participantConsent = payload
    }
  },
  NEW_MESSAGE_LISTENER (state, payload) {
    if (payload) {
      const index = state.messageListeners.findIndex(listener => listener === payload)
      if (index < 0) {
        state.messageListeners.push(payload)
      }
    }
  },
  ADD_NEW_MESSAGE (state, payload) {
    if (payload) {
      const index = state.messageThread.findIndex(message => message._id === payload.message._id)
      if (index < 0) {
        state.newMessage = payload
        if (payload.message.threadId === state.activeThread) {
          state.messageThread.push(payload.message)
        }
      }
    }
  },
  ADD_NEW_SIGN_UP (state, payload) {
    if (payload) {
      state.newSignup = payload
    }
  },
  UPDATE_UNREAD (state, payload) {
    state.hasUnread = payload
  },
  SET_CAN_SEND (state, payload) {
    state.canSend = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/store/messaging/mutations.js